export default __webpack_public_path__ + "static/media/artStudioPic.6f4ddcfd.png";